module.exports = __webpack_public_path__ + "img/login-bg-text.fa1bb4fd.png";